import { call, put } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import {
  changeCourseStatusActions,
  getDetailsCourseActions,
  updateCourseStatusAction,
} from "../slices";
import { has } from "lodash";
import { showSuccessToast } from "@helpers";

function* changeCourseStatusWorker({ payload }) {
  try {
    yield put(changeCourseStatusActions.pending());
    const response = yield call(courseAPI.changeCourseStatus, payload);
    yield put(changeCourseStatusActions.success(response));
    yield put(updateCourseStatusAction(payload));
    showSuccessToast("Course's status updated successfully");
    if (payload.data[1]) {
      yield put(
        getDetailsCourseActions.updateStatus({ status: payload.data[1] })
      );
    }
    if (has(payload, "onSuccess")) {
      payload.onSuccess();
    }
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(changeCourseStatusActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { changeCourseStatusWorker };
